var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:_vm.isLoginPage ? 'login-footer' : 'page-footer'},[_c('p',[_vm._v(_vm._s(_vm.$t('Copyright')))])])}
var staticRenderFns = []

export { render, staticRenderFns }